<template>
    <div id="ModalCorreo" class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">

                <div class="modal-header">
                    <h5 class="modal-title">
                        Enviar factura  {{ correoFactura.factura }} 
                    </h5>

                    <button type="button" class="close" data-dismiss="modal">
                        <span>&times;</span>
                    </button>
                </div>

                <div class="modal-body pad10">

                    <div>
                        Nombre:
                    </div>
                    <div>
                        <input class="form-control" v-model.trim="correoFactura.nombre" maxlength="255">
                    </div>
                    <div>
                        Correo:
                    </div>
                    <div>
                        <input class="form-control" type="email" v-model.trim="correoFactura.correo" maxlength="255">
                    </div>

                    <div class="text-center">
                        <button class="btn btn-primary"
                            :disabled="loading || !correoFactura.nombre || !correoFactura.correo"
                            @click="confirmarReenvioCorreo">
                            <i class="fa-solid fa-paper-plane"></i>
                            Enviar nuevamente
                        </button>
                    </div>

                    <br />
                    <hr />

                    <div class="text-center">
                        <i class="fa-solid fa-clock-rotate-left"></i>
                        Historial de envíos
                    </div>

                    <div v-if="loading" class="text-center py-5">
                        <i class="fa-solid fa-spinner fa-spin fa-2x text-primary"></i>
                        <div class="mt-3 text-muted">
                            Consultando historial de envíos...
                        </div>
                    </div>

                    <template v-else>

                        <div v-if="correoFactura.historial.length">

                            <div v-for="(item, index) in correoFactura.historial" :key="index" class="historial-item">

                                <div class="d-flex justify-content-between align-items-center">

                                    <strong>{{ item.notificacion_destinatario }}</strong>

                                    <span v-if="item.fecha_notificacion" class="badge badge-success">
                                        <i class="fa-solid fa-check-circle"></i>
                                        Enviado
                                    </span>

                                    <span v-else class="badge badge-warning">
                                        <i class="fa-solid fa-clock"></i>
                                        Pendiente
                                    </span>

                                </div>

                                <div class="text-muted small">
                                    <i class="fa-solid fa-envelope mr-1"></i>
                                    {{ item.notificacion_correo }}
                                </div>

                                <div class="small text-muted" v-if="item.fecha_notificacion">
                                    <i class="fa-solid fa-paper-plane mx-1"></i>
                                    {{ item.fecha_notificacion }}
                                </div>

                            </div>

                        </div>

                        <div class="text-center text-muted py-4" v-else>
                            <i class="fa-regular fa-envelope-open fa-lg mb-2"></i><br>
                            No existen envíos registrados para esta factura.
                        </div>

                    </template>

                </div>

                <div class="modal-footer">
                    <button class="btn btn-secondary" data-dismiss="modal">
                        Cerrar
                    </button>


                </div>

            </div>
        </div>
    </div>
</template>

<style scoped>
.historial-item {
    padding: .75rem 0;
    border-bottom: 1px solid #ececec;
}

.historial-item:last-child {
    border-bottom: none;
}

.historial-item strong {
    font-size: .95rem;
    font-weight: 600;
}

.historial-item .small {
    line-height: 1.35;
}

.badge {
    font-size: .72rem;
    font-weight: 500;
}

.modal-body {
    max-height: 70vh;
    overflow-y: auto;
}
</style>
<script>
import Swal from "sweetalert2";
import GLOBAL from "../../../Global.js";
import ReporteService from "../../../service/ReporteService";

export default {
    data() {
        return {
            reporteService: new ReporteService(),
            loading: false,
            person: null,
            correoFactura: {
                uniqueid: null,
                factura: "",
                nombre: "",
                correo: "",
                historial: []
            }
        };
    },

    created() {
        this.person = JSON.parse(sessionStorage.getItem(GLOBAL.SESSION_KEY));
    },

    methods: {
        async show(factura) {
            this.correoFactura = {
                uniqueid: factura.uniqueid,
                factura: factura.prefijo + "-" + factura.consecutivo,
                nombre: "",
                correo: "",
                historial: []
            };

            $("#ModalCorreo").modal("show");
            await this.cargarHistorial();
        },

        async cargarHistorial() {
            this.loading = true;

            try {
                const response = await this.reporteService.getDetalleCorreo(this.person, this.correoFactura.uniqueid);

                this.correoFactura.historial = response.data || [];

                if (this.correoFactura.historial.length) {
                    this.correoFactura.nombre = this.correoFactura.historial[0].notificacion_destinatario || "";
                    this.correoFactura.correo = this.correoFactura.historial[0].notificacion_correo || "";
                } else {
                    this.correoFactura.nombre = "";
                    this.correoFactura.correo = "";
                }
            } catch (e) {
                console.error(e);
                this.correoFactura.nombre = "";
                this.correoFactura.correo = "";
                this.correoFactura.historial = [];

                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: "No fue posible consultar el historial de envíos."
                });
            } finally {
                this.loading = false;
            }
        },

        async confirmarReenvioCorreo() {

            if (!this.correoFactura.nombre.trim()) {
                Swal.fire({
                    icon: "warning",
                    title: "Destinatario requerido",
                    text: "Debe indicar el nombre del destinatario."
                });
                return;
            }

            if (!this.correoFactura.correo.trim()) {
                Swal.fire({
                    icon: "warning",
                    title: "Correo requerido",
                    text: "Debe indicar el correo electrónico."
                });
                return;
            }

            this.loading = true;

            try {
                await this.reporteService.reenviarCorreo(this.person, {
                    uniqueid: this.correoFactura.uniqueid,
                    nombre: this.correoFactura.nombre,
                    correo: this.correoFactura.correo
                });

                await this.cargarHistorial();

                Swal.fire({
                    icon: "success",
                    title: "Solicitud registrada",
                    text: "El reenvío fue agregado a la cola de procesamiento.",
                    timer: 2000,
                    showConfirmButton: false
                });

            } catch (e) {
                console.error(e);

                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: "No fue posible registrar la solicitud de reenvío."
                });
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>